export enum ENVIRONMENT {
    LOCAL = 'local',
    NST = 'nst',
    ALP = 'alp',
    STG = 'stg',
    TST = 'tst',
    PRD = 'prd',
}
